// extracted by mini-css-extract-plugin
export default {"result":"_0vkPA","copy":"OpvUU","input":"EX8j2"};